import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useMealModel } from "../mealModel";
export const DataBox = () => {
    const { setIVisibleDrawer } = useMealModel();
    const onAdd = () => {
        setIVisibleDrawer("add")
    }
    const title = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onAdd}
        >新增</Button>
    </>
    return (
        <YhBox title={title}>
            <DataTable />
        </YhBox>
    )
}